import { Record } from 'types/index';

import { STORAGE_NAME } from '../../constants';

import { SessionStorageData, StorageApi, StorageRecords } from '../types';

/**
 * SessionStorage
 */
export class SessionStorage implements StorageApi {
  private _storage: typeof sessionStorage;

  /**
   *
   */
  constructor() {
    this._storage = sessionStorage;
  }

  /**
   * @returns Returns data from sessionStorage
   */
  get storage() {
    return this._storage.getItem(STORAGE_NAME) !== null
      ? JSON.parse(this._storage.getItem(STORAGE_NAME) as string)
      : {};
  }

  /**
   *
   * @param newData {SessionStorageData} - Updated data
   *
   * Update data in sessionStorage from local state
   */
  set storage(newData: SessionStorageData) {
    this._storage.setItem(STORAGE_NAME, JSON.stringify(newData));
  }

  /**
   * Add Record to storage
   *
   * @param record
   *
   * @returns Returns element index in storage
   */
  addRecord(record: Record): number {
    const index = Object.keys(this.storage).length;
    const newData = {
      ...this.storage,
      [`${index}`]: record,
    };

    this.storage = newData;

    return index;
  }

  /**
   * Get all records from storage
   *
   * @returns Returns all records from storage ordered by index
   */
  getRecords(): StorageRecords {
    return Object.entries(this.storage)
      .sort(([aKey], [bKey]) => parseInt(aKey, 10) - parseInt(bKey, 10))
      .map(([, record]) => record);
  }

  /**
   * Clear all records from storage
   */
  clearRecords(): void {
    this.storage = {};
  }
}
